// Import Swiper and Fancybox
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Fancybox } from "@fancyapps/ui";

export function initSliders() {
  (function ($) {
    const videos_swiper = new Swiper(".videos-slider .swiper", {
      modules: [Navigation, Pagination],
      // Optional parameters
      loop: true,
      slidesPerView: 3,
      spaceBetween: 5,
      observer: true,
      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
      },

      // Navigation arrows
      navigation: {
        nextEl: ".videos-slider .swiper-button-next",
        prevEl: ".videos-slider .swiper-button-prev",
      },
    });

    const posts_swiper = new Swiper(".posts-slider .swiper", {
      modules: [Navigation, Pagination],
      // Optional parameters
      loop: true,
      slidesPerView: 3,
      spaceBetween: 5,
      observer: true,
      observeParents: true,
      // If we need pagination
      pagination: {
        el: ".posts-slider .swiper-pagination",
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: ".posts-slider .swiper-button-next",
        prevEl: ".posts-slider .swiper-button-prev",
      },
    });

    const image_swiper = new Swiper(".single-industry #industry_gallery .swiper", {
      modules: [Navigation, Pagination, Autoplay],
      // Optional parameters
      loop: false,
      slidesPerView: 3,
      spaceBetween: 5,
      observer: true,
      observeParents: true,
      pagination: {
        el: "#industry_gallery .swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 5000,
      },

      // Navigation arrows
      navigation: {
        nextEl: "#industry_gallery .swiper-button-next",
        prevEl: "#industry_gallery .swiper-button-prev",
      },
      on: {
        afterInit: function () {
          //industryInfo.find('#industry_gallery').slideDown();
          Fancybox.bind('[data-fancybox="gallery"]', {
            // Your custom options here
          });
        },
      },
    });
    //   $ppLg = $(this).data("pp-lg") ? $(this).data("pp-lg") : 3;
    //   $ppMd = $(this).data("pp-md") ? $(this).data("pp-md") : 2;
    //   $ppSm = $(this).data("pp-sm") ? $(this).data("pp-sm") : 1;
    //   var imagesCarousel = new Swiper(slider, {
    //     direction: "horizontal",
    //     loop: true,
    //     slidesPerView: 3,
    //     spaceBetween: 5,
    //     speed: 300,
    //     observer: true,
    //     navigation: {
    //       nextEl: $(".posts-slider .swiper-button-next"),
    //       prevEl: $(".posts-slider .swiper-button-prev"),
    //     },
    //     pagination: {
    //       el: ".swiper-pagination",
    //       clickable: true,
    //     },
    //     breakpoints: {
    //       640: {
    //         slidesPerView: $ppSm,
    //       },
    //       768: {
    //         slidesPerView: $ppMd,
    //       },
    //       1024: {
    //         slidesPerView: $ppLg,
    //       },
    //     },
    //   });
    // });
  })(jQuery);
}
